import { NewPaymentComponent } from '../new-payment/new-payment.component';
import { MapfreAlertComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreCardComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreInfoDivsComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { HeaderComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NewPaymentService } from '../../../../_services/forms/new-payment/new-payment.service';
import { BillingDataService } from '../../../../_services/data-services/billing-data.service';
import { PolicyDataService } from '../../../../_services/data-services/policy-data.service';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreInfoDivsComponent, MapfreCardComponent, MapfreAlertComponent, NewPaymentComponent],
  selector: 'app-ach-payment',
  templateUrl: './ach-payment.component.html',
})
export class AchPaymentComponent implements OnInit {
  policy: any;
  billingDetails: any;

  @Output() closeNewPayment = new EventEmitter();
  inputs: any;
  newPaymentForm = true;
  policyId: string;
  isIEBrowser: boolean;
  isAcmic: boolean;
  invalidRouting: boolean;
  constructor(
    private service: NewPaymentService,
    private billingDataService: BillingDataService,
    private policyDataService: PolicyDataService,
    private activatedRoute: ActivatedRoute,
    private acmicService: AcmicService,
    
  ) {
    this.isAcmic = false;
    this.invalidRouting=false;
  }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.isIEBrowser = true;
    }
    this.billingDataService.$billingDetails.subscribe((currentBill) => {
      this.billingDetails = currentBill;
    });
    this.policyDataService.$policyDetails.subscribe((policy) => {
      this.policy = policy[0];
    });
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.inputs = this.service.getInputsForAchGuest(this.policyId);
    });
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['invalidRouting'] == 'Y') {
        this.invalidRouting = true;
      }
    });
  }

  openConfirmModal() {
    this.closeNewPayment.emit(true);
  }
}
